var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('v-btn',{staticClass:"m-4",attrs:{"fab":"","large":"","right":"","dark":"","bottom":"","fixed":"","color":""},on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("@/assets/doordash-2.png"),"alt":"","width":"80px"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }